const SharedSubscriptionConstants = require("./SharedSubscriptionConstants");
const SubscriptionStatuses = SharedSubscriptionConstants.statuses;
const SubscriptionPricing = SharedSubscriptionConstants.pricing;
const currentPricing = SubscriptionPricing[SharedSubscriptionConstants.currentPricingVersion];
const SubscriptionPlans = SharedSubscriptionConstants.plans;

const SharedSubscriptionUtilities = {
  isLegacyPremiumUser(subscription) {
    return subscription && subscription.legacyPricing && subscription.legacyPricing.version;
  },

  getLegacyPricingVersion(subscription) {
    return subscription?.legacyPricing?.version;
  },

  isLegacyPriceID(priceID) {
    const defaultPriceIDs = [currentPricing.monthly.priceID, currentPricing.annual.priceID, currentPricing.lifetime.priceID]; // default prices are those prices all users can always access
    return !defaultPriceIDs.includes(priceID); // if price is default price, then standard price; otherwise legacy price
  },

  isLifetimePriceID(priceID) {
    return priceID === SharedSubscriptionUtilities.getLifetimePriceID();
  },

  getLifetimePriceID() {
    return currentPricing.lifetime.priceID;
  },

  /**
   * There are FIVE states:
   * 1. Active —> Premium
   * 2. Active (Set To Cancel) —> Premium
   * 3. Past Due —> Booking restricted
   * 4. Cancelled —> Free plan
   * 5. Unactivated —> Free plan
   */
  getSubscriptionPlanInfo(subscription, currency = "usd", currencySymbol = "$") {
    let subscriptionInfo = SubscriptionPlans.free;

    if (subscription.status === SubscriptionStatuses.ACTIVE || subscription.status === SubscriptionStatuses.PAST_DUE) {
      const subscriptionPlan = SharedSubscriptionUtilities.getSubscriptionPlanByPriceID(subscription.priceID);
      if (subscriptionPlan && subscriptionPlan.type && subscriptionPlan.prices) {
        const type = subscriptionPlan.type; // monthly, annual, lifetime
        const price = subscriptionPlan.prices[currency];

        if (subscription.cancel_at_period_end) {
          subscriptionInfo = SubscriptionPlans.cancel_at_period_end;
        } else if (subscription.status === SubscriptionStatuses.PAST_DUE) {
          subscriptionInfo = SubscriptionPlans.past_due;
        } else {
          /** Monthly, annual, lifetime plan */
          subscriptionInfo = SubscriptionPlans[type];
        }
        /** Add price tag information to subscription info if applicable */
        if (type === "monthly") {
          subscriptionInfo["priceTag"] = `${currencySymbol}${price}/month`;
        } else if (type === "annual") {
          subscriptionInfo["priceTag"] = `${currencySymbol}${price}/year`;
        }
      }
    }

    if (!subscriptionInfo || !subscriptionInfo.plan || !subscriptionInfo.description) {
      subscriptionInfo = SubscriptionPlans.unknown_plan;
    }

    return subscriptionInfo;
  },

  /** Traverses pricing versions until it finds matching plan */
  getSubscriptionPlanByPriceID(priceID) {
    let subscriptionPlan = null;

    /** pricingVersionKey might be 'january2024', 'buymeacoffee2023', etc. */
    for (const pricingVersionKey in SubscriptionPricing) {
      const pricingVersion = SubscriptionPricing[pricingVersionKey];
      /** pricingPlanType might be 'monthly', 'annual', 'lifetime', etc */
      for (const pricingPlanType in pricingVersion) {
        const plan = pricingVersion[pricingPlanType];
        if ((plan["priceID"] && plan["priceID"] === priceID) || plan["archivedPriceIDs"]?.includes(priceID)) {
          subscriptionPlan = plan;
          subscriptionPlan["type"] = pricingPlanType;
          break;
        }
      }
      if (subscriptionPlan) {
        break;
      }
    }
    return subscriptionPlan;
  },
};

module.exports = SharedSubscriptionUtilities;
